
export const contestTypes = Object.freeze({
    Standard: 'Standard',
    KnockoutPlus: 'Knockout Plus'
});
